import React, { useMemo } from "react";
import * as echarts from "echarts";
import { default as EchartsWrapper } from "src/components/Echarts";
import { peerAnalyticsPublishType } from "src/types/analytics";
import { getPublisherRTTChartConfiguration } from "../../helpers/getPublishConfigurations";
type echartsOptions = echarts.EChartsOption;

export const PublisherRoundTripChart = ({
  publishData,
  loading,
}: {
  publishData: peerAnalyticsPublishType;
  loading: boolean;
}) => {
  const peerPublisherRoundTripChartoptions: echartsOptions = useMemo(
    () => getPublisherRTTChartConfiguration(publishData),
    [publishData]
  );

  return (
    <>
      {/* @ts-ignore */}
      <EchartsWrapper
        options={{ ...peerPublisherRoundTripChartoptions }}
        loading={loading}
        style={{ height: "240px", width: "auto" }}
      />
    </>
  );
};
